import { useState } from 'react'

/** Escudo de equipo con fallback silencioso -- si no hay URL o la imagen falla al cargar
 * (proveedor caído, equipo sin escudo sincronizado), se muestra un icono neutro en vez de
 * un hueco roto o un alt-text feo. */
function getInitials(name: string): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
  return (parts[0][0] + parts[1][0]).toUpperCase()
}

function getPalette(name: string) {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % 5
  const PALETTES = [
    'from-amber-600/40 to-amber-950/80 text-amber-300 border-amber-500/40',
    'from-cyan-600/40 to-cyan-950/80 text-cyan-300 border-cyan-500/40',
    'from-emerald-600/40 to-emerald-950/80 text-emerald-300 border-emerald-500/40',
    'from-violet-600/40 to-violet-950/80 text-violet-300 border-violet-500/40',
    'from-rose-600/40 to-rose-950/80 text-rose-300 border-rose-500/40',
  ]
  return PALETTES[index]
}

export function TeamCrest({ src, alt, size = 24, className = '' }: { src?: string | null; alt: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false)

  if (!src || failed) {
    const initials = getInitials(alt)
    const palette = getPalette(alt)
    return (
      <span
        className={`inline-flex items-center justify-center rounded-lg border bg-gradient-to-br font-mono font-bold tracking-wider shrink-0 shadow-inner select-none ${palette} ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.4)) }}
        title={alt}
      >
        {initials}
      </span>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={`rounded-lg object-contain shrink-0 filter drop-shadow p-0.5 border border-border bg-panel-elevated ${className}`}
      onError={() => setFailed(true)}
      loading="lazy"
    />
  )
}
